var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4AllowanceDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_88106",
    "data-name": "Group 88106",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 398,
    height: 384.623,
    viewBox: "0 0 398 384.623",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25462",
    "data-name": "Rectangle 25462",
    width: 398,
    height: 384.623,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25427",
    "data-name": "Rectangle 25427",
    width: 322.602,
    height: 322.457,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25429",
    "data-name": "Rectangle 25429",
    width: 49.408,
    height: 62.472,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25431",
    "data-name": "Rectangle 25431",
    width: 56.688,
    height: 32.784,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25433",
    "data-name": "Rectangle 25433",
    width: 56.688,
    height: 32.783,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25435",
    "data-name": "Rectangle 25435",
    width: 33.998,
    height: 57.285,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25437",
    "data-name": "Rectangle 25437",
    width: 61.766,
    height: 57.565,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25439",
    "data-name": "Rectangle 25439",
    width: 61.765,
    height: 57.566,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25441",
    "data-name": "Rectangle 25441",
    width: 61.766,
    height: 57.566,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25445",
    "data-name": "Rectangle 25445",
    width: 56.011,
    height: 62.288,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25447",
    "data-name": "Rectangle 25447",
    width: 56.01,
    height: 62.289,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25454",
    "data-name": "Rectangle 25454",
    width: 48.498,
    height: 64.731,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25455",
    "data-name": "Rectangle 25455",
    width: 68.268,
    height: 68.448,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25456",
    "data-name": "Rectangle 25456",
    width: 80.74,
    height: 70.277,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25457",
    "data-name": "Rectangle 25457",
    width: 98.077,
    height: 62.795,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25458",
    "data-name": "Rectangle 25458",
    width: 94.743,
    height: 59.217,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25459",
    "data-name": "Rectangle 25459",
    width: 120.953,
    height: 58.326,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25460",
    "data-name": "Rectangle 25460",
    width: 103.424,
    height: 53.276,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_87725",
    "data-name": "Group 87725",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87724",
    "data-name": "Group 87724"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87723",
    "data-name": "Group 87723",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87674",
    "data-name": "Group 87674",
    transform: "translate(45.193 172.332)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87673",
    "data-name": "Group 87673"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87672",
    "data-name": "Group 87672",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25428",
    "data-name": "Rectangle 25428",
    width: 54.35,
    height: 29.028,
    transform: "translate(0.523 50.326) rotate(-66.396)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276110",
    "data-name": "Path 276110",
    d: "M37.224,70.827c-.069-.031-.133-.064-.2-.1l-17,38.907a1.66,1.66,0,0,1,.2.077,2.129,2.129,0,0,1,1.1,2.8,2.1,2.1,0,0,1-.3.494l16.631,7.269a2.1,2.1,0,0,1,.156-.56,2.13,2.13,0,0,1,2.8-1.1L57.6,79.734a2.126,2.126,0,0,1-1.1-2.8l-16.482-7.2A2.126,2.126,0,0,1,37.224,70.827ZM41.841,87.76A7.839,7.839,0,1,1,31.52,91.8,7.84,7.84,0,0,1,41.841,87.76Z",
    transform: "translate(-13.998 -63.706)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87677",
    "data-name": "Group 87677",
    transform: "translate(105.167 280.568)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87676",
    "data-name": "Group 87676"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87675",
    "data-name": "Group 87675",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25430",
    "data-name": "Rectangle 25430",
    width: 54.35,
    height: 29.026,
    transform: "matrix(0.999, -0.055, 0.055, 0.999, 0.417, 3.383)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276111",
    "data-name": "Path 276111",
    d: "M46,135.793a2.111,2.111,0,0,1,0,.22L88.393,133.7c-.01-.072-.018-.143-.023-.217a2.128,2.128,0,0,1,2.01-2.241,2.083,2.083,0,0,1,.581.049l-.99-18.122a2.232,2.232,0,0,1-.573.113,2.128,2.128,0,0,1-2.241-2.01l-42.373,2.315a2.126,2.126,0,0,1-2.008,2.241l.98,17.961A2.126,2.126,0,0,1,46,135.793Zm13.047-11.74a7.839,7.839,0,1,1,8.254,7.4A7.839,7.839,0,0,1,59.045,124.053Z",
    transform: "translate(-38.528 -107.232)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87680",
    "data-name": "Group 87680",
    transform: "translate(166.315 80.584)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87679",
    "data-name": "Group 87679"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87678",
    "data-name": "Group 87678",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25432",
    "data-name": "Rectangle 25432",
    width: 54.35,
    height: 29.026,
    transform: "translate(0.417 3.382) rotate(-3.127)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276112",
    "data-name": "Path 276112",
    d: "M69.9,57.606a2.107,2.107,0,0,1,0,.22L112.3,55.511c-.01-.072-.018-.143-.023-.217a2.128,2.128,0,0,1,2.01-2.241,2.083,2.083,0,0,1,.581.049l-.99-18.122a2.232,2.232,0,0,1-.573.113,2.128,2.128,0,0,1-2.241-2.01L68.692,35.4a2.126,2.126,0,0,1-2.008,2.241l.98,17.961A2.126,2.126,0,0,1,69.9,57.606Zm13.047-11.74a7.839,7.839,0,1,1,8.254,7.4A7.839,7.839,0,0,1,82.952,45.866Z",
    transform: "translate(-62.434 -29.048)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87683",
    "data-name": "Group 87683",
    transform: "translate(319.529 229.087)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87682",
    "data-name": "Group 87682"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87681",
    "data-name": "Group 87681",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25434",
    "data-name": "Rectangle 25434",
    width: 54.349,
    height: 29.026,
    transform: "translate(0.426 54.612) rotate(-85.563)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276113",
    "data-name": "Path 276113",
    d: "M130.06,93.239c-.074-.008-.146-.015-.217-.028l-3.284,42.329a2.146,2.146,0,0,1,2.177,2.292,2.2,2.2,0,0,1-.125.57l18.094,1.4a2.21,2.21,0,0,1-.036-.583,2.13,2.13,0,0,1,2.287-1.957l3.282-42.309a2.125,2.125,0,0,1-1.957-2.287L132.346,91.28A2.13,2.13,0,0,1,130.06,93.239Zm9.922,14.477a7.839,7.839,0,1,1-8.423,7.208A7.837,7.837,0,0,1,139.981,107.716Z",
    transform: "translate(-122.376 -86.891)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87686",
    "data-name": "Group 87686",
    transform: "translate(256.873 95.414)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87685",
    "data-name": "Group 87685"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87684",
    "data-name": "Group 87684",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25436",
    "data-name": "Rectangle 25436",
    width: 54.349,
    height: 29.026,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0.559, 34.216)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276114",
    "data-name": "Path 276114",
    d: "M137.25,40.075c-.046-.056-.087-.118-.128-.176L103.786,66.193a1.793,1.793,0,0,1,.146.164,2.118,2.118,0,0,1-.857,3.282l11.242,14.252a2.157,2.157,0,0,1,.4-.422,2.13,2.13,0,0,1,2.99.353l33.318-26.279a2.128,2.128,0,0,1,.353-2.99L140.24,40.428A2.128,2.128,0,0,1,137.25,40.075Zm-3.911,17.112a7.838,7.838,0,1,1-11.009-1.3A7.838,7.838,0,0,1,133.339,57.187Z",
    transform: "translate(-96.302 -33.259)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87689",
    "data-name": "Group 87689",
    transform: "translate(112.958 9.423)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87688",
    "data-name": "Group 87688"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87687",
    "data-name": "Group 87687",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25438",
    "data-name": "Rectangle 25438",
    width: 54.349,
    height: 29.026,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0.559, 34.216)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276115",
    "data-name": "Path 276115",
    d: "M80.985,6.456c-.046-.056-.087-.118-.128-.176L47.521,32.574a1.8,1.8,0,0,1,.146.164,2.118,2.118,0,0,1-.857,3.282L58.052,50.272a2.158,2.158,0,0,1,.4-.422,2.13,2.13,0,0,1,2.99.353L94.761,23.924a2.128,2.128,0,0,1,.353-2.99L83.975,6.809A2.128,2.128,0,0,1,80.985,6.456ZM77.074,23.568a7.839,7.839,0,1,1-11.009-1.3A7.838,7.838,0,0,1,77.074,23.568Z",
    transform: "translate(-40.037 0.36)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87692",
    "data-name": "Group 87692",
    transform: "translate(210.247 205.942)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87691",
    "data-name": "Group 87691"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87690",
    "data-name": "Group 87690",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25440",
    "data-name": "Rectangle 25440",
    width: 54.349,
    height: 29.026,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0.559, 34.217)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276116",
    "data-name": "Path 276116",
    d: "M119.021,83.287c-.046-.056-.087-.118-.128-.176L85.557,109.405a1.8,1.8,0,0,1,.146.164,2.118,2.118,0,0,1-.857,3.282L96.088,127.1a2.158,2.158,0,0,1,.4-.422,2.13,2.13,0,0,1,2.99.353L132.8,100.752a2.125,2.125,0,0,1,.353-2.988L122.011,83.64A2.128,2.128,0,0,1,119.021,83.287ZM115.11,100.4A7.838,7.838,0,1,1,104.1,99.1,7.838,7.838,0,0,1,115.11,100.4Z",
    transform: "translate(-78.073 -76.471)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87695",
    "data-name": "Group 87695",
    transform: "translate(153.356 322.688)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87694",
    "data-name": "Group 87694"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87693",
    "data-name": "Group 87693",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25442",
    "data-name": "Rectangle 25442",
    width: 54.349,
    height: 29.026,
    transform: "matrix(0.785, -0.619, 0.619, 0.785, 0.559, 34.217)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276117",
    "data-name": "Path 276117",
    d: "M96.779,128.93c-.046-.056-.087-.118-.128-.176L63.315,155.048a1.794,1.794,0,0,1,.146.164,2.118,2.118,0,0,1-.857,3.282l11.242,14.252a2.157,2.157,0,0,1,.4-.422,2.13,2.13,0,0,1,2.99.353L110.555,146.4a2.125,2.125,0,0,1,.353-2.988L99.769,129.283A2.128,2.128,0,0,1,96.779,128.93Zm-3.911,17.112a7.839,7.839,0,1,1-11.009-1.3A7.838,7.838,0,0,1,92.868,146.042Z",
    transform: "translate(-55.831 -122.114)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87698",
    "data-name": "Group 87698",
    transform: "translate(284.942 322.334)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87697",
    "data-name": "Group 87697"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87696",
    "data-name": "Group 87696",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25444",
    "data-name": "Rectangle 25444",
    width: 29.026,
    height: 54.349,
    transform: "matrix(0.82, -0.572, 0.572, 0.82, 0.553, 17.161)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276118",
    "data-name": "Path 276118",
    d: "M114.122,141.836a2.073,2.073,0,0,1-.187.118l24.294,34.819a1.835,1.835,0,0,1,.174-.133,2.127,2.127,0,0,1,2.962.527,2.16,2.16,0,0,1,.263.519L156.512,167.3a2.186,2.186,0,0,1-.4-.427,2.127,2.127,0,0,1,.529-2.962l-24.281-34.8a2.129,2.129,0,0,1-2.964-.527l-14.751,10.293A2.126,2.126,0,0,1,114.122,141.836Zm16.851,4.908a7.839,7.839,0,1,1-1.944,10.914A7.84,7.84,0,0,1,130.973,146.744Z",
    transform: "translate(-107.453 -122.03)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87701",
    "data-name": "Group 87701",
    transform: "translate(25.825 310.497)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87700",
    "data-name": "Group 87700"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87699",
    "data-name": "Group 87699",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25446",
    "data-name": "Rectangle 25446",
    width: 29.026,
    height: 54.349,
    transform: "matrix(0.82, -0.572, 0.572, 0.82, 0.554, 17.161)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276119",
    "data-name": "Path 276119",
    d: "M12.818,137.209a2.064,2.064,0,0,1-.187.118l24.294,34.819a1.837,1.837,0,0,1,.174-.133,2.127,2.127,0,0,1,2.962.527,2.161,2.161,0,0,1,.263.519l14.884-10.385a2.181,2.181,0,0,1-.4-.427,2.127,2.127,0,0,1,.529-2.962l-24.281-34.8a2.129,2.129,0,0,1-2.965-.527L13.345,134.247A2.126,2.126,0,0,1,12.818,137.209Zm16.851,4.908a7.839,7.839,0,1,1-1.944,10.914A7.84,7.84,0,0,1,29.669,142.117Z",
    transform: "translate(-6.149 -117.401)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25448",
    "data-name": "Rectangle 25448",
    width: 12.735,
    height: 12.735,
    transform: "translate(48.885 75.834)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10944",
    "data-name": "Line 10944",
    x2: 31.129,
    transform: "translate(65.866 81.493)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10945",
    "data-name": "Line 10945",
    x2: 31.129,
    transform: "translate(65.866 81.493)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25449",
    "data-name": "Rectangle 25449",
    width: 12.735,
    height: 12.735,
    transform: "translate(48.885 53.195)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10946",
    "data-name": "Line 10946",
    x2: 31.129,
    transform: "translate(65.866 58.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10947",
    "data-name": "Line 10947",
    x2: 31.129,
    transform: "translate(65.866 58.854)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25450",
    "data-name": "Rectangle 25450",
    width: 12.735,
    height: 12.735,
    transform: "translate(48.885 30.556)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10948",
    "data-name": "Line 10948",
    x2: 31.129,
    transform: "translate(65.866 36.215)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10949",
    "data-name": "Line 10949",
    x2: 31.129,
    transform: "translate(65.866 36.215)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276120",
    "data-name": "Path 276120",
    d: "M20.355,17.5l3.156,4.88,12.917-11.2",
    transform: "translate(31.71 17.424)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276121",
    "data-name": "Path 276121",
    d: "M20.131,25.267l3.445,4.594,11.193-9.474",
    transform: "translate(31.36 31.759)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276122",
    "data-name": "Path 276122",
    d: "M20.131,34.1l3.445,4.594,11.193-9.474",
    transform: "translate(31.36 45.518)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25451",
    "data-name": "Rectangle 25451",
    width: 12.735,
    height: 12.735,
    transform: "translate(48.885 145.422)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10950",
    "data-name": "Line 10950",
    x2: 31.129,
    transform: "translate(65.866 151.081)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10951",
    "data-name": "Line 10951",
    x2: 31.129,
    transform: "translate(65.866 151.081)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25452",
    "data-name": "Rectangle 25452",
    width: 12.735,
    height: 12.735,
    transform: "translate(48.885 122.782)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10952",
    "data-name": "Line 10952",
    x2: 31.129,
    transform: "translate(65.866 128.442)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10953",
    "data-name": "Line 10953",
    x2: 31.129,
    transform: "translate(65.866 128.442)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25453",
    "data-name": "Rectangle 25453",
    width: 12.735,
    height: 12.735,
    transform: "translate(48.885 100.143)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10954",
    "data-name": "Line 10954",
    x2: 31.129,
    transform: "translate(65.866 105.803)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10955",
    "data-name": "Line 10955",
    x2: 31.129,
    transform: "translate(65.866 105.803)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276123",
    "data-name": "Path 276123",
    d: "M20.355,44.706l3.156,4.88,12.917-11.2",
    transform: "translate(31.71 59.806)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276124",
    "data-name": "Path 276124",
    d: "M20.131,52.473l3.445,4.594,11.193-9.474",
    transform: "translate(31.36 74.141)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276125",
    "data-name": "Path 276125",
    d: "M20.131,61.305,23.576,65.9l11.193-9.474",
    transform: "translate(31.36 87.9)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276126",
    "data-name": "Path 276126",
    d: "M112.741,32.592s11.71,2.046,17.015-.148a44.956,44.956,0,0,0,9.484-5.481l-11.894-6.717-11.689,6.63Z",
    transform: "translate(175.629 31.538)",
    fill: "#fec47a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276127",
    "data-name": "Path 276127",
    d: "M112.741,32.592s11.71,2.046,17.015-.148a44.956,44.956,0,0,0,9.484-5.481l-11.894-6.717-11.689,6.63Z",
    transform: "translate(175.629 31.538)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276128",
    "data-name": "Path 276128",
    d: "M95.581,129.423l.87,1.862,3.274-1.484,2.473,5.29,3.271-1.486,2.473,5.29,3.274-1.484,2.473,5.29,3.271-1.486,2.471,5.29,3.274-1.486,2.473,5.292,3.274-1.486,2.294,4.908c2.7-4.99,6.484-13.528,6.932-22.808.706-14.587-2.867-18.457-5.545-31.052s-1.655-51.964-1.655-51.964l-38.2-31.553s.844,36.71,1.123,51.591-.5,29.016,4.752,43.022c3.589,9.559.041,15.587-2.576,18.455",
    transform: "translate(143.756 25.478)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276129",
    "data-name": "Path 276129",
    d: "M95.581,129.423l.87,1.862,3.274-1.484,2.473,5.29,3.271-1.486,2.473,5.29,3.274-1.484,2.473,5.29,3.271-1.486,2.471,5.29,3.274-1.486,2.473,5.292,3.274-1.486,2.294,4.908c2.7-4.99,6.484-13.528,6.932-22.808.706-14.587-2.867-18.457-5.545-31.052s-1.655-51.964-1.655-51.964l-38.2-31.553s.844,36.71,1.123,51.591-.5,29.016,4.752,43.022C101.745,120.527,98.2,126.556,95.581,129.423Z",
    transform: "translate(143.756 25.478)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10956",
    "data-name": "Line 10956",
    x2: 13.173,
    y2: 6.952,
    transform: "translate(239.267 84.921)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10957",
    "data-name": "Line 10957",
    x2: 13.173,
    y2: 6.952,
    transform: "translate(239.267 84.921)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10958",
    "data-name": "Line 10958",
    x2: 13.173,
    y2: 6.952,
    transform: "translate(257.022 92.689)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10959",
    "data-name": "Line 10959",
    x2: 13.173,
    y2: 6.952,
    transform: "translate(257.022 92.689)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10960",
    "data-name": "Line 10960",
    x2: 13.173,
    y2: 6.952,
    transform: "translate(257.74 101.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10961",
    "data-name": "Line 10961",
    x2: 13.173,
    y2: 6.952,
    transform: "translate(257.74 101.4)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10962",
    "data-name": "Line 10962",
    x2: 13.173,
    y2: 6.952,
    transform: "translate(258.33 108.169)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10963",
    "data-name": "Line 10963",
    x2: 13.173,
    y2: 6.952,
    transform: "translate(258.33 108.169)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10964",
    "data-name": "Line 10964",
    x2: 13.173,
    y2: 6.952,
    transform: "translate(259.21 114.887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10965",
    "data-name": "Line 10965",
    x2: 13.173,
    y2: 6.952,
    transform: "translate(259.21 114.887)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10966",
    "data-name": "Line 10966",
    x2: 13.173,
    y2: 6.952,
    transform: "translate(259.612 122.286)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10967",
    "data-name": "Line 10967",
    x2: 13.173,
    y2: 6.952,
    transform: "translate(259.612 122.286)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10968",
    "data-name": "Line 10968",
    x2: 13.173,
    y2: 6.952,
    transform: "translate(260.783 128.953)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10969",
    "data-name": "Line 10969",
    x2: 13.173,
    y2: 6.952,
    transform: "translate(260.783 128.953)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10970",
    "data-name": "Line 10970",
    x2: 13.035,
    y2: 6.548,
    transform: "translate(263.656 138.139)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10971",
    "data-name": "Line 10971",
    x2: 13.035,
    y2: 6.548,
    transform: "translate(263.656 138.139)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10972",
    "data-name": "Line 10972",
    x2: 10.958,
    y2: 6.274,
    transform: "translate(265.916 147.168)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10973",
    "data-name": "Line 10973",
    x2: 10.958,
    y2: 6.274,
    transform: "translate(265.916 147.168)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10974",
    "data-name": "Line 10974",
    x2: 10.756,
    y2: 7.162,
    transform: "translate(265.66 155.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10975",
    "data-name": "Line 10975",
    x2: 10.756,
    y2: 7.162,
    transform: "translate(265.66 155.626)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10976",
    "data-name": "Line 10976",
    x2: 13.173,
    y2: 6.952,
    transform: "translate(239.182 92.705)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10977",
    "data-name": "Line 10977",
    x2: 13.173,
    y2: 6.952,
    transform: "translate(239.182 92.705)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10978",
    "data-name": "Line 10978",
    x2: 13.173,
    y2: 6.952,
    transform: "translate(239.823 99.763)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10979",
    "data-name": "Line 10979",
    x2: 13.173,
    y2: 6.952,
    transform: "translate(239.823 99.763)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10980",
    "data-name": "Line 10980",
    x2: 13.173,
    y2: 6.952,
    transform: "translate(240.515 107.112)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10981",
    "data-name": "Line 10981",
    x2: 13.173,
    y2: 6.952,
    transform: "translate(240.515 107.112)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10982",
    "data-name": "Line 10982",
    x2: 13.173,
    y2: 6.952,
    transform: "translate(240.816 113.932)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10983",
    "data-name": "Line 10983",
    x2: 13.173,
    y2: 6.952,
    transform: "translate(240.816 113.932)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10984",
    "data-name": "Line 10984",
    x2: 13.173,
    y2: 6.952,
    transform: "translate(241.116 120.752)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10985",
    "data-name": "Line 10985",
    x2: 13.173,
    y2: 6.952,
    transform: "translate(241.116 120.752)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10986",
    "data-name": "Line 10986",
    x2: 13.173,
    y2: 6.952,
    transform: "translate(242.337 127.709)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10987",
    "data-name": "Line 10987",
    x2: 13.173,
    y2: 6.952,
    transform: "translate(242.337 127.709)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10988",
    "data-name": "Line 10988",
    x2: 11.745,
    y2: 6.279,
    transform: "translate(244.733 136.252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10989",
    "data-name": "Line 10989",
    x2: 11.745,
    y2: 6.279,
    transform: "translate(244.733 136.252)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10990",
    "data-name": "Line 10990",
    x2: 9.009,
    y2: 5.612,
    transform: "translate(247.45 144.355)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10991",
    "data-name": "Line 10991",
    x2: 9.009,
    y2: 5.612,
    transform: "translate(247.45 144.355)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276130",
    "data-name": "Path 276130",
    d: "M249.063.156H218.822C204.291,8.743,191.308,16,190.244,16.554c-4.013,2.085-24.831,4.269-30.274,4.351s-30.99-6.842-34.628-5.543-4.192.609-6.175,3.207S100.726,43.823,99.989,46.557,95.28,69.58,95.352,74.245s.524,8.94,2.407,9.922,3.908,1.108,5.52-.317,2.113-4.233,2.849-6.967a10.736,10.736,0,0,0,.159-4.983s11.206,5.353,13.07,5.169,4.55-2.558,4.55-2.558a24.5,24.5,0,0,0,4.747.084c1.629-.258,11.559-2.276,14.175-4.029s4.438-5.047,4.179-6.676a30.381,30.381,0,0,0-1.312-4.415l7.873-4.087s14.2,8.108,23.187,5.4,16.068-7.558,17.063-8.663a23.245,23.245,0,0,1,4.389-2.867l50.854-14.549Z",
    transform: "translate(148.538 0.243)",
    fill: "#fec47a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276131",
    "data-name": "Path 276131",
    d: "M249.063.156H218.822C204.291,8.743,191.308,16,190.244,16.554c-4.013,2.085-24.831,4.269-30.274,4.351s-30.99-6.842-34.628-5.543-4.192.609-6.175,3.207S100.726,43.823,99.989,46.557,95.28,69.58,95.352,74.245s.524,8.94,2.407,9.922,3.908,1.108,5.52-.317,2.113-4.233,2.849-6.967a10.736,10.736,0,0,0,.159-4.983s11.206,5.353,13.07,5.169,4.55-2.558,4.55-2.558a24.5,24.5,0,0,0,4.747.084c1.629-.258,11.559-2.276,14.175-4.029s4.438-5.047,4.179-6.676a30.381,30.381,0,0,0-1.312-4.415l7.873-4.087s14.2,8.108,23.187,5.4,16.068-7.558,17.063-8.663a23.245,23.245,0,0,1,4.389-2.867l50.854-14.549Z",
    transform: "translate(148.538 0.243)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276132",
    "data-name": "Path 276132",
    d: "M116.811,18.7s-10.541,12.919-9.732,14.851,3.046,5.868,4.934,7.239,4.714,3.041,6.814,2.931,5.018-2.409,5.218-4.671a4.193,4.193,0,0,0-.67-3.179",
    transform: "translate(166.74 29.125)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276133",
    "data-name": "Path 276133",
    d: "M112.527,31.381s6.213-5.773,6.412-8.034",
    transform: "translate(175.295 36.37)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276134",
    "data-name": "Path 276134",
    d: "M115.079,15.474s-14.132,12.04-13.694,15.145,3.484,14.262,4.908,15.874c0,0,3.8,4.3,8.231,4.154",
    transform: "translate(157.921 24.106)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276135",
    "data-name": "Path 276135",
    d: "M116.474,11.643S99.73,25.823,98.426,27.087s-1.78,5.63-.87,9.272,2.985,12.17,3.64,14.183,1.287,2.857,2.386,3.463",
    transform: "translate(151.242 18.138)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276136",
    "data-name": "Path 276136",
    d: "M116.463,7.626s-3.673-1.033-5.9,1.1a27.228,27.228,0,0,0-3.44,3.944",
    transform: "translate(166.883 11.491)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276137",
    "data-name": "Path 276137",
    d: "M118.093,11.025c-.872-1.256-5.507.082-6.336,2.9",
    transform: "translate(174.096 16.438)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276138",
    "data-name": "Path 276138",
    d: "M119.431,14.5a5.687,5.687,0,0,0-3.55,1.844l-1.143,1.573",
    transform: "translate(178.738 22.593)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276139",
    "data-name": "Path 276139",
    d: "M233.438,53.857C207.394,52,190.1,48.682,189.774,48.695a67.837,67.837,0,0,0-23.4,1.44c-12.638,3.1-42.035,5.694-42.035,5.694s-4.543,1.471-5,2.287-11.408,27.75-12.922,31.435a10.791,10.791,0,0,0,.21,9.7c1.537,2.982,9.431,8.431,13.935,12.792s7.443,8.658,9.5,6.87,1.489-5.563,1.489-5.563,19.808-2.586,23.788-3.039,5.494.652,5.924-2.039-2.264-5.517-2.264-5.517,2.417-2.918,1.65-4.41-3.89-1.627-5.88-1.4-8.638,2.128-8.638,2.128-3.144-2.01-2.783-3.141,4.428-8.459,4.428-8.459a48.159,48.159,0,0,0,5.451-.7c3.256-.591,5.788-1.315,8.254-.478s11.4,1.532,14.654.944,11.733-6.269,11.733-6.269l45.565,9.919Z",
    transform: "translate(164.163 75.19)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276140",
    "data-name": "Path 276140",
    d: "M233.438,53.857C207.394,52,190.1,48.682,189.774,48.695a67.837,67.837,0,0,0-23.4,1.44c-12.638,3.1-42.035,5.694-42.035,5.694s-4.543,1.471-5,2.287-11.408,27.75-12.922,31.435a10.791,10.791,0,0,0,.21,9.7c1.537,2.982,9.431,8.431,13.935,12.792s7.443,8.658,9.5,6.87,1.489-5.563,1.489-5.563,19.808-2.586,23.788-3.039,5.494.652,5.924-2.039-2.264-5.517-2.264-5.517,2.417-2.918,1.65-4.41-3.89-1.627-5.88-1.4-8.638,2.128-8.638,2.128-3.144-2.01-2.783-3.141,4.428-8.459,4.428-8.459a48.159,48.159,0,0,0,5.451-.7c3.256-.591,5.788-1.315,8.254-.478s11.4,1.532,14.654.944,11.733-6.269,11.733-6.269l45.565,9.919Z",
    transform: "translate(164.163 75.19)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276141",
    "data-name": "Path 276141",
    d: "M144.464,48.879l-2.156,55.3,20.483,5.389,1.077-59.61Z",
    transform: "translate(221.688 76.145)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276142",
    "data-name": "Path 276142",
    d: "M144.464,48.879l-2.156,55.3,20.483,5.389,1.077-59.61Z",
    transform: "translate(221.688 76.145)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276143",
    "data-name": "Path 276143",
    d: "M163.439,50.1l-12.045-.8-1.079,59.607,13.124,3.154Z",
    transform: "translate(234.162 76.801)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276144",
    "data-name": "Path 276144",
    d: "M163.439,50.1l-12.045-.8-1.079,59.607,13.124,3.154Z",
    transform: "translate(234.162 76.801)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276145",
    "data-name": "Path 276145",
    d: "M113.937,55.917s1.744,5.494,5.906,8.07",
    transform: "translate(177.492 87.108)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276146",
    "data-name": "Path 276146",
    d: "M111.056,58.482s.839,4.727,4.118,6.013",
    transform: "translate(173.004 91.104)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276147",
    "data-name": "Path 276147",
    d: "M112.389,68.842l-.179,1.765s6.919,3.839,8.709,10.692",
    transform: "translate(174.802 107.243)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276148",
    "data-name": "Path 276148",
    d: "M114.4,67.834l3.89,4.023s8.369,1.714,9.95,1.261,12.277-4.369,16.71-.842",
    transform: "translate(178.216 105.672)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276149",
    "data-name": "Path 276149",
    d: "M126.839,73.1l-4.162-.179-4.908-2.192s2.645-3.325,1.084-5.788",
    transform: "translate(183.461 101.166)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276150",
    "data-name": "Path 276150",
    d: "M119.813,69.909s5.021-.409,6.016,3.072a5.454,5.454,0,0,1-1.174,5.474",
    transform: "translate(186.646 108.882)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276151",
    "data-name": "Path 276151",
    d: "M100.08,56.889s34.149,19.764,40.815,24.294,20.769,8.666,20.769,8.666-.018,48.476.269,60.707,2.136,46.69,2.136,46.69S143.683,186.7,134,180.7c-7.671-4.758-35.331-23.877-35.331-23.877s-.529-35,.169-54.594c.645-18.012,1.238-45.34,1.238-45.34",
    transform: "translate(153.414 88.622)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276152",
    "data-name": "Path 276152",
    d: "M100.08,56.889s34.149,19.764,40.815,24.294,20.769,8.666,20.769,8.666-.018,48.476.269,60.707,2.136,46.69,2.136,46.69S143.683,186.7,134,180.7c-7.671-4.758-35.331-23.877-35.331-23.877s-.529-35,.169-54.594C99.486,84.217,100.08,56.889,100.08,56.889Z",
    transform: "translate(153.414 88.622)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276153",
    "data-name": "Path 276153",
    d: "M100.214,73.611l51.246,29.1L152.1,160.7l-20.278-11.761-.356-12.357A214.715,214.715,0,0,1,100.211,117.7Z",
    transform: "translate(156.109 114.672)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10992",
    "data-name": "Line 10992",
    x2: 9.303,
    y2: 4.637,
    transform: "translate(296.601 191.417)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10993",
    "data-name": "Line 10993",
    x2: 9.303,
    y2: 4.637,
    transform: "translate(296.326 196.279)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10994",
    "data-name": "Line 10994",
    x2: 9.303,
    y2: 4.637,
    transform: "translate(296.051 201.141)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276154",
    "data-name": "Path 276154",
    d: "M100.275,81.29l51.23,30.3-.049-8.886-51.246-29.1Z",
    transform: "translate(156.11 114.672)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276155",
    "data-name": "Path 276155",
    d: "M100.275,81.29l51.23,30.3-.049-8.886-51.246-29.1Z",
    transform: "translate(156.11 114.672)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10995",
    "data-name": "Line 10995",
    x1: 0.215,
    y1: 36.832,
    transform: "translate(287.364 214.423)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10996",
    "data-name": "Line 10996",
    x2: 50.325,
    y2: 28.474,
    transform: "translate(256.937 206.201)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10997",
    "data-name": "Line 10997",
    x2: 11.185,
    y2: 6.2,
    transform: "translate(257.758 215.102)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10998",
    "data-name": "Line 10998",
    x2: 11.185,
    y2: 6.2,
    transform: "translate(257.758 215.102)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_10999",
    "data-name": "Line 10999",
    x2: 11.185,
    y2: 6.2,
    transform: "translate(258.035 220.05)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11000",
    "data-name": "Line 11000",
    x2: 11.185,
    y2: 6.2,
    transform: "translate(258.035 220.05)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11001",
    "data-name": "Line 11001",
    x2: 11.185,
    y2: 6.2,
    transform: "translate(291.067 232.415)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11002",
    "data-name": "Line 11002",
    x2: 11.185,
    y2: 6.2,
    transform: "translate(291.067 232.415)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11003",
    "data-name": "Line 11003",
    x2: 11.185,
    y2: 6.2,
    transform: "translate(291.253 240.381)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11004",
    "data-name": "Line 11004",
    x2: 11.185,
    y2: 6.2,
    transform: "translate(291.253 240.381)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11005",
    "data-name": "Line 11005",
    x2: 11.185,
    y2: 6.2,
    transform: "translate(291.44 248.347)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11006",
    "data-name": "Line 11006",
    x2: 11.185,
    y2: 6.2,
    transform: "translate(291.44 248.347)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11007",
    "data-name": "Line 11007",
    x2: 11.185,
    y2: 6.2,
    transform: "translate(291.627 256.312)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11008",
    "data-name": "Line 11008",
    x2: 11.185,
    y2: 6.2,
    transform: "translate(291.627 256.312)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11009",
    "data-name": "Line 11009",
    x2: 11.185,
    y2: 6.2,
    transform: "translate(258.114 225.702)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11010",
    "data-name": "Line 11010",
    x2: 11.185,
    y2: 6.2,
    transform: "translate(258.114 225.702)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276156",
    "data-name": "Path 276156",
    d: "M141.015,56.277s-1.558,4.727-8.228,7.149-11.756,6.788-17.316,10.093-11.868,9.39-9.221,13.255,8.392,3.591,14.224,1.238,19.214-13.035,23.693-12.945A123.258,123.258,0,0,0,161.1,73.816c4.929-.726,9.745-3.645,15.963-7.65",
    transform: "translate(164.546 87.669)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276157",
    "data-name": "Path 276157",
    d: "M141.015,56.277s-1.558,4.727-8.228,7.149-11.756,6.788-17.316,10.093-11.868,9.39-9.221,13.255,8.392,3.591,14.224,1.238,19.214-13.035,23.693-12.945A123.258,123.258,0,0,0,161.1,73.816c4.929-.726,9.745-3.645,15.963-7.65",
    transform: "translate(164.546 87.669)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276158",
    "data-name": "Path 276158",
    d: "M83.459,58.46l-7.3-.043S64.843,92.733,60.541,104.839s-6.515,30.2-6.515,30.2L97.539,79.849Z",
    transform: "translate(84.162 91.002)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276159",
    "data-name": "Path 276159",
    d: "M83.459,58.46l-7.3-.043S64.843,92.733,60.541,104.839s-6.515,30.2-6.515,30.2L97.539,79.849Z",
    transform: "translate(84.162 91.002)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276160",
    "data-name": "Path 276160",
    d: "M107.848,60.851l-27.586-2.89s-15.129,35.482-18.69,51.2S54.5,133.294,54.5,133.294,73,116.041,87.764,96.453s24.872-33.379,24.872-33.379Z",
    transform: "translate(84.901 90.292)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276161",
    "data-name": "Path 276161",
    d: "M107.848,60.851l-27.586-2.89s-15.129,35.482-18.69,51.2S54.5,133.294,54.5,133.294,73,116.041,87.764,96.453s24.872-33.379,24.872-33.379Z",
    transform: "translate(84.901 90.292)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87704",
    "data-name": "Group 87704",
    transform: "translate(145.544 151.514)",
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87703",
    "data-name": "Group 87703"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87702",
    "data-name": "Group 87702",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276162",
    "data-name": "Path 276162",
    d: "M105.4,60.853l-1.926-.113-25.5-1.5s-12.886,30.617-16.04,42.173S56.9,123.966,56.9,123.966Z",
    transform: "translate(-56.902 -59.236)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276163",
    "data-name": "Path 276163",
    d: "M75.771,70.849c3.067,1.929,2.921,7.679-.325,12.84S67.08,91.47,64.013,89.542s-2.921-7.679.325-12.84,8.367-7.781,11.433-5.852",
    transform: "translate(96.28 109.382)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276164",
    "data-name": "Path 276164",
    d: "M75.771,70.849c3.067,1.929,2.921,7.679-.325,12.84S67.08,91.47,64.013,89.542s-2.921-7.679.325-12.84S72.7,68.921,75.771,70.849Z",
    transform: "translate(96.28 109.382)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276165",
    "data-name": "Path 276165",
    d: "M126.264,61.862,110.548,58.3S89.106,93.1,76.78,106.928s-23.951,28.312-23.951,28.312,15.869-6.6,42.654-28.358,36.04-39.467,36.04-39.467Z",
    transform: "translate(82.297 90.823)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276166",
    "data-name": "Path 276166",
    d: "M126.264,61.862,110.548,58.3S89.106,93.1,76.78,106.928s-23.951,28.312-23.951,28.312,15.869-6.6,42.654-28.358,36.04-39.467,36.04-39.467Z",
    transform: "translate(82.297 90.823)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87707",
    "data-name": "Group 87707",
    transform: "translate(141.914 153.131)",
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87706",
    "data-name": "Group 87706"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87705",
    "data-name": "Group 87705",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276167",
    "data-name": "Path 276167",
    d: "M119.959,60.878l-12.347-1.01S89.46,86.541,79.51,98.944s-24.028,29.374-24.028,29.374,21.22-15.595,34.64-31.052S123.75,61.7,123.75,61.7Z",
    transform: "translate(-55.483 -59.868)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276168",
    "data-name": "Path 276168",
    d: "M140.849,65.608l-15.086-6.481s-27.8,32.75-46.2,51.89-26.018,22.938-26.018,22.938l-1.177,4.673s25.547-8.934,49.9-33.589S141.46,68.289,141.46,68.289Z",
    transform: "translate(81.581 92.109)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276169",
    "data-name": "Path 276169",
    d: "M140.849,65.608l-15.086-6.481s-27.8,32.75-46.2,51.89-26.018,22.938-26.018,22.938l-1.177,4.673s25.547-8.934,49.9-33.589S141.46,68.289,141.46,68.289Z",
    transform: "translate(81.581 92.109)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87710",
    "data-name": "Group 87710",
    transform: "translate(140.464 154.959)",
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87709",
    "data-name": "Group 87709"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87708",
    "data-name": "Group 87708",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276170",
    "data-name": "Path 276170",
    d: "M135.656,65.44l-11.022-4.857S97.12,90.031,84.561,103.03s-29.645,27.829-29.645,27.829a61.294,61.294,0,0,0,27.223-14.3c12.219-11.418,53.517-51.12,53.517-51.12",
    transform: "translate(-54.915 -60.582)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276171",
    "data-name": "Path 276171",
    d: "M157.032,70.714,145.056,61.24s-54.3,45.447-66.7,53.131a272.709,272.709,0,0,1-24.765,13.472l-4.141,6.76s14.564.89,47.568-16.618S158.856,74,158.856,74Z",
    transform: "translate(77.038 95.4)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276172",
    "data-name": "Path 276172",
    d: "M157.032,70.714,145.056,61.24s-54.3,45.447-66.7,53.131a272.709,272.709,0,0,1-24.765,13.472l-4.141,6.76s14.564.89,47.568-16.618S158.856,74,158.856,74Z",
    transform: "translate(77.038 95.4)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87713",
    "data-name": "Group 87713",
    transform: "translate(137.819 161.02)",
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87712",
    "data-name": "Group 87712"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87711",
    "data-name": "Group 87711",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276173",
    "data-name": "Path 276173",
    d: "M149.369,69.6l-10.39-6.653s-37.93,29.806-49.834,38.5a283.1,283.1,0,0,1-25.271,16.636l-9.993,5.545,3.264,2.11s12.454-.637,32.84-11.948,61.973-42.465,61.973-42.465Z",
    transform: "translate(-53.882 -62.953)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276174",
    "data-name": "Path 276174",
    d: "M85.19,78.949c1.228,2.215-2.1,6.407-7.433,9.364s-10.648,3.563-11.876,1.351,2.1-6.4,7.43-9.359,10.651-3.568,11.878-1.356",
    transform: "translate(102.233 120.913)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276175",
    "data-name": "Path 276175",
    d: "M85.19,78.949c1.228,2.215-2.1,6.407-7.433,9.364s-10.648,3.563-11.876,1.351,2.1-6.4,7.43-9.359S83.962,76.737,85.19,78.949Z",
    transform: "translate(102.233 120.913)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276176",
    "data-name": "Path 276176",
    d: "M163.693,73.325l-4.284-9.175s-34.287,29.236-58.321,42.572a275.707,275.707,0,0,1-48.954,20.716L48.413,133.8s20.191.079,55.98-18.705S163.734,81.63,163.734,81.63Z",
    transform: "translate(75.418 99.933)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276177",
    "data-name": "Path 276177",
    d: "M163.693,73.325l-4.284-9.175s-34.287,29.236-58.321,42.572a275.707,275.707,0,0,1-48.954,20.716L48.413,133.8s20.191.079,55.98-18.705S163.734,81.63,163.734,81.63Z",
    transform: "translate(75.418 99.933)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87716",
    "data-name": "Group 87716",
    transform: "translate(144.047 167.672)",
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87715",
    "data-name": "Group 87715"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87714",
    "data-name": "Group 87714",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276178",
    "data-name": "Path 276178",
    d: "M151.06,73.467l-5.484-7.914S117.2,89.563,105.29,97.582s-38.6,21.191-42.984,22.158a23.1,23.1,0,0,0-5.99,1.913l4.55,3.118s17.585-4.4,38.142-16.654S150.333,77.1,150.333,77.1Z",
    transform: "translate(-56.318 -65.553)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276179",
    "data-name": "Path 276179",
    d: "M166.122,88.44s3.4-2.143,4.154-8.75,1.148-11.224,1.148-11.224-44.606,25.98-61.252,34.188a170.563,170.563,0,0,1-38.178,13.278c-4.32.762-18.357,3.195-18.357,3.195l-8.576,10.185a63.081,63.081,0,0,0,34.794-.732c18.813-5.855,63.853-21.11,68.306-23.235s17.961-16.9,17.961-16.9",
    transform: "translate(70.196 106.657)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276180",
    "data-name": "Path 276180",
    d: "M166.122,88.44s3.4-2.143,4.154-8.75,1.148-11.224,1.148-11.224-44.606,25.98-61.252,34.188a170.563,170.563,0,0,1-38.178,13.278c-4.32.762-18.357,3.195-18.357,3.195l-8.576,10.185a63.081,63.081,0,0,0,34.794-.732c18.813-5.855,63.853-21.11,68.306-23.235S166.122,88.44,166.122,88.44Z",
    transform: "translate(70.196 106.657)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87719",
    "data-name": "Group 87719",
    transform: "translate(118.3 178.339)",
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87718",
    "data-name": "Group 87718"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87717",
    "data-name": "Group 87717",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276181",
    "data-name": "Path 276181",
    d: "M164.27,86.482s2.993-8.456,2.929-10.768.005-5.99.005-5.99S134.929,87.732,123.445,95.3,87.3,112.29,82.031,113.244s-29.3,5.141-29.3,5.141l-6.476,9.339s18.143,2.01,36.114-3.965,50.517-15.784,51.363-16.188,12.582-4.185,12.582-4.185Z",
    transform: "translate(-46.251 -69.723)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276182",
    "data-name": "Path 276182",
    d: "M86.114,84.649c1.09,2.284-2.489,6.264-7.991,8.891s-10.848,2.906-11.937.622,2.486-6.264,7.991-8.891,10.848-2.906,11.937-.622",
    transform: "translate(102.801 129.458)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276183",
    "data-name": "Path 276183",
    d: "M86.114,84.649c1.09,2.284-2.489,6.264-7.991,8.891s-10.848,2.906-11.937.622,2.486-6.264,7.991-8.891S85.024,82.365,86.114,84.649Z",
    transform: "translate(102.801 129.458)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276184",
    "data-name": "Path 276184",
    d: "M85.4,123.928s33.313-11.8,41.119-13.449a75.718,75.718,0,0,1,16.311-1.279L162.5,73.519s-25.161,8.367-38.2,14.853S91.3,105.423,86.982,106.185s-25.46,1.742-25.46,1.742L50.715,130.006l6.418,3.292,5.144,2.384Z",
    transform: "translate(79.004 114.528)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276185",
    "data-name": "Path 276185",
    d: "M85.4,123.928s33.313-11.8,41.119-13.449a75.718,75.718,0,0,1,16.311-1.279L162.5,73.519s-25.161,8.367-38.2,14.853S91.3,105.423,86.982,106.185s-25.46,1.742-25.46,1.742L50.715,130.006l6.418,3.292,5.144,2.384Z",
    transform: "translate(79.004 114.528)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_87722",
    "data-name": "Group 87722",
    transform: "translate(132.762 191.629)",
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87721",
    "data-name": "Group 87721"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87720",
    "data-name": "Group 87720",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276186",
    "data-name": "Path 276186",
    d: "M155.329,74.919,139.286,101.84s-18.148,3.977-30.4,7.748-31.318,11.827-34.287,13.242-4.149,2.762-6.146,2.936S51.9,128.2,51.9,128.2l8.888-20.644s24.1-1.87,25.258-2.164,36.8-18.347,43.462-20.749,25.816-9.72,25.816-9.72",
    transform: "translate(-51.906 -74.919)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_276187",
    "data-name": "Path 276187",
    d: "M85.442,86.48c1.09,2.284-2.489,6.264-7.991,8.891s-10.848,2.906-11.937.622S68,89.728,73.5,87.1,84.352,84.2,85.442,86.48",
    transform: "translate(101.754 132.31)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276188",
    "data-name": "Path 276188",
    d: "M85.442,86.48c1.09,2.284-2.489,6.264-7.991,8.891s-10.848,2.906-11.937.622S68,89.728,73.5,87.1,84.352,84.2,85.442,86.48Z",
    transform: "translate(101.754 132.31)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276189",
    "data-name": "Path 276189",
    d: "M28.18,112.638S54,94.9,55.886,94s17.329-3.118,19.629-3.7a10.663,10.663,0,0,1,7.364,1.384C84.73,92.861,99.993,94.6,102.093,93.6s10.917-5.213,12.889-4.865,4.44,1.747,2.916,5.568-9.472,11.482-12.421,13.406l-2.949,1.921,6.5-2.586,16.357-6.776s-1.274,7.052-1.512,8.712,2.113,3.888-2.325,7.553-8.763,7.021-8.763,7.021a34.553,34.553,0,0,1-2.824,6.5c-1.719,2.883-1.939,3.5-1.967,5.064s-2.169,10.571-5.108,11.976-9.712,1.8-12.293.711-11.022-.409-11.022-.409-29.865.079-33.714.113a31.157,31.157,0,0,0-8.671,1.819l-2.939,1.4-9.2-37.628Z",
    transform: "translate(39.022 138.193)",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276190",
    "data-name": "Path 276190",
    d: "M28.18,112.638S54,94.9,55.886,94s17.329-3.118,19.629-3.7a10.663,10.663,0,0,1,7.364,1.384C84.73,92.861,99.993,94.6,102.093,93.6s10.917-5.213,12.889-4.865,4.44,1.747,2.916,5.568-9.472,11.482-12.421,13.406l-2.949,1.921,6.5-2.586,16.357-6.776s-1.274,7.052-1.512,8.712,2.113,3.888-2.325,7.553-8.763,7.021-8.763,7.021a34.553,34.553,0,0,1-2.824,6.5c-1.719,2.883-1.939,3.5-1.967,5.064s-2.169,10.571-5.108,11.976-9.712,1.8-12.293.711-11.022-.409-11.022-.409-29.865.079-33.714.113a31.157,31.157,0,0,0-8.671,1.819l-2.939,1.4-9.2-37.628Z",
    transform: "translate(39.022 138.193)",
    fill: "none",
    stroke: "#515255",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276191",
    "data-name": "Path 276191",
    d: "M26.492,104.27l8.446,20.818-4.873,2.356Z",
    transform: "translate(41.269 162.432)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276192",
    "data-name": "Path 276192",
    d: "M26.492,104.27l8.446,20.818-4.873,2.356Z",
    transform: "translate(41.269 162.432)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276193",
    "data-name": "Path 276193",
    d: "M55.624,102.417s7.835-1.987,11.889.593a13.385,13.385,0,0,1,5.269,7.088s3.86-1.737,3.663-4.947l-.2-3.213,1.512-8.712Z",
    transform: "translate(86.651 145.23)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276194",
    "data-name": "Path 276194",
    d: "M55.624,102.417s7.835-1.987,11.889.593a13.385,13.385,0,0,1,5.269,7.088s3.86-1.737,3.663-4.947l-.2-3.213,1.512-8.712Z",
    transform: "translate(86.651 145.23)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276195",
    "data-name": "Path 276195",
    d: "M47.835,95.734s3.952.176,5.591,1.455a29.627,29.627,0,0,0,4.325,2.576l3.867-1.074,5.412-.005",
    transform: "translate(74.518 149.135)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276196",
    "data-name": "Path 276196",
    d: "M68.911,102.926s-3.517,4.515-3.947,5.236-3.734,5.134-6.453,5.916-6.653-.435-6.653-.435,5.793,4.325,8.344,3.525,8.709-14.242,8.709-14.242",
    transform: "translate(80.785 160.339)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276197",
    "data-name": "Path 276197",
    d: "M68.911,102.926s-3.517,4.515-3.947,5.236-3.734,5.134-6.453,5.916-6.653-.435-6.653-.435,5.793,4.325,8.344,3.525S68.911,102.926,68.911,102.926Z",
    transform: "translate(80.785 160.339)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276198",
    "data-name": "Path 276198",
    d: "M15.961,105.337s22.181-9.449,22.473-8.3.772,3.238.772,3.238l9.2,37.628s3.867,16.2,3.136,16.291-20.964,5.515-20.964,5.515Z",
    transform: "translate(24.864 151.017)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276199",
    "data-name": "Path 276199",
    d: "M15.961,105.337s22.181-9.449,22.473-8.3.772,3.238.772,3.238l9.2,37.628s3.867,16.2,3.136,16.291-20.964,5.515-20.964,5.515Z",
    transform: "translate(24.864 151.017)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276200",
    "data-name": "Path 276200",
    d: "M.155,196.007l59.776-20.457s-2.259-13.628-3.9-19.508c-2.248-8.042-2.307-17.787-5.637-29.049-3.164-10.707-4.335-29.481-4.335-29.481-1.422-1.9-9.876,1.108-9.876,1.108L.155,109Z",
    transform: "translate(0.241 150.924)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_276201",
    "data-name": "Path 276201",
    d: "M.155,196.007l59.776-20.457s-2.259-13.628-3.9-19.508c-2.248-8.042-2.307-17.787-5.637-29.049-3.164-10.707-4.335-29.481-4.335-29.481-1.422-1.9-9.876,1.108-9.876,1.108L.155,109Z",
    transform: "translate(0.241 150.924)",
    fill: "none",
    stroke: "#515255",
    strokeMiterlimit: 10,
    strokeWidth: 0.311
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4AllowanceDashboard);
export default __webpack_public_path__ + "static/media/4_allowance__Dashboard.9ecc03b55ea7006775837a7d37131fa9.svg";
export { ForwardRef as ReactComponent };